import getRows from '../utils/getRows'
import { useEffect } from 'react'

interface useInitProps {
  setRows: Function
  setShowModal: Function
  setShowOverlay: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    getRows({
      setShowModal: props.setShowModal,
    })
    .then((data: any) => {
      props.setRows(data)
      props.setShowOverlay(false)
    })
  }, [])
}

export default useInit
